import { render, staticRenderFns } from "./NavBar.vue?vue&type=template&id=b127fc86&scoped=true&"
import script from "./nav-bar.ts?vue&type=script&lang=ts&"
export * from "./nav-bar.ts?vue&type=script&lang=ts&"
import style0 from "./NavBar.vue?vue&type=style&index=0&id=b127fc86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b127fc86",
  null
  
)

export default component.exports